import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className", "hasBack", "history", "style", "hasSeparator", "goBackTo", "backButtonTooltipTitle", "onBack", "goBackHandler", "isBackDisabled", "contentClassName", "backButtonClassName"],
  _excluded2 = ["staticContext"];
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import cx from 'classnames';
import _isFunction from 'lodash/isFunction';
import styles from './pageComponent.module.scss';
import Button from '../../atoms/Button';
import ToolTip from '../../atoms/tooltip';
var Header = function Header(_ref) {
  var children = _ref.children,
    className = _ref.className,
    hasBack = _ref.hasBack,
    history = _ref.history,
    style = _ref.style,
    hasSeparator = _ref.hasSeparator,
    goBackTo = _ref.goBackTo,
    backButtonTooltipTitle = _ref.backButtonTooltipTitle,
    onBack = _ref.onBack,
    goBackHandler = _ref.goBackHandler,
    isBackDisabled = _ref.isBackDisabled,
    contentClassName = _ref.contentClassName,
    backButtonClassName = _ref.backButtonClassName,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  var goBack = function goBack() {
    if (_isFunction(onBack)) return onBack();
    if (!goBackTo) return history.goBack();
    return history.push(goBackTo);
  };
  var staticContext = extraProps.staticContext,
    rest = _objectWithoutProperties(extraProps, _excluded2);
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", _extends({
    className: cx(styles.headerContainer, className),
    style: style,
    sectiontype: "general"
  }, rest), hasBack && /*#__PURE__*/React.createElement(ToolTip, {
    placement: "bottom",
    trigger: "hover",
    title: backButtonTooltipTitle
  }, /*#__PURE__*/React.createElement(Button, {
    view: Button.VIEW.ICON,
    onClick: goBackHandler || goBack,
    className: cx(styles.goBackBtn, backButtonClassName),
    iconClassName: styles.goBackIcon,
    icon: "icon-chevron-down",
    disabled: isBackDisabled
  })), /*#__PURE__*/React.createElement("div", {
    className: cx(styles.headerContent, contentClassName)
  }, children)), hasSeparator && /*#__PURE__*/React.createElement("hr", {
    className: styles.separator
  }));
};
Header.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  className: PropTypes.object,
  hasBack: PropTypes.bool,
  hasSeparator: PropTypes.bool,
  goBackTo: PropTypes.string,
  history: PropTypes.object.isRequired,
  style: PropTypes.object,
  contentClassName: PropTypes.string,
  backButtonTooltipTitle: PropTypes.string,
  backButtonClassName: PropTypes.string
};
Header.defaultProps = {
  children: null,
  className: null,
  hasBack: false,
  hasSeparator: false,
  goBackTo: '',
  style: null,
  contentClassName: '',
  backButtonTooltipTitle: null,
  backButtonClassName: ''
};
export default withRouter(Header);